<div class="stretched-column-container column-gap-1">
  <div #overview class="overlap-children">
    <div *ngIf="!companies" @fadeInOut
         class="stretched-column-container section-item-wrapper column-gap-1">
      <div class="flex row-gap-1p25">
        <div class="width-7 height-7 bg-black-3 br-0p5"></div>
        <div class="flex row-gap-2">
          <div class="vertical-container-simple column-gap-0p5" *ngFor="let i of [].constructor(5)">
            <div class="width-5 height-1 bg-black-3 br-0p25"></div>
            <div class="width-7p5 height-1p25 bg-black-3 br-0p25"></div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <app-kpi-metrics-company-overview
        *ngIf="selectedCompany"
        @fadeInOut
        class="width-100pcnt"
        [companies]="companies"
        [selectedCompany]="selectedCompany"
        (updateCompanyList)="updateCompanyList($event)"
        (goToCompany)="goToCompany($event)">
      </app-kpi-metrics-company-overview>
    </div>
  </div>

  <!-- metrics-->
  <app-company-metrics-kpi
    *ngIf="selectedCompany"
    [selectedCompany]="selectedCompany">
  </app-company-metrics-kpi>
</div>

<div
  *ngIf="companies && !companies.length"
  @fadeInOut2
  class="height-60vh">
  <app-empty-state-standard
    [isAdmin]="is.admin"
    [heading]="'No companies yet'"
    [buttonText]="'Company'"
    [buttonIconName]="'plus.svg'"
    (buttonClick)="showCompanyCRUDModal()">
  </app-empty-state-standard>
</div>

<app-modal-company-crud
  *ngIf="showCompanyCrud"
  [company]="selectedCompanyForCrudModal"
  (companyCommonEmitter)="closeCompanyCrudModal(!!$event)">
</app-modal-company-crud>
